import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MarketService } from "../../../../../../../shared/src/lib/services/market.service";
import { AsyncPipe } from "@angular/common";
import { MHeaderComponent } from "../m-header/m-header.component";
import { DisplayModeService } from "../../../../../../../shared/src/lib/services/display-mode.service";
import { MatIconModule } from "@angular/material/icon";

const homeSports = [
  { id: "4", label: "cricket" },
  { id: "1", label: "soccer" },
  { id: "2", label: "tennis" },
];

@Component({
  selector: "app-header-navigation",
  imports: [RouterModule, TranslateModule, AsyncPipe, MHeaderComponent, MatIconModule],
  templateUrl: "./header-navigation.component.html",
  styleUrl: "./header-navigation.component.scss",
})
export class HeaderNavigationComponent implements OnInit {
  navService = inject(NavService);
  translate = inject(TranslateService);
  marketService = inject(MarketService);
  router = inject(Router);
  displayModeService = inject(DisplayModeService);
  private readonly destroyRef = inject(DestroyRef);

  defaultSport: string | null = null;

  ngOnInit() {
    this.checkSportVisibility();
  }

  checkSportVisibility() {
    this.marketService.sports$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((sports) => {
      const visible = homeSports.filter((hsp) => sports.some((sp) => sp.id === hsp.id));
      this.defaultSport = visible.length > 0 ? visible?.[0]?.label : null;
    });
  }

  goHomeDefaultSport(e: MouseEvent) {
    e.preventDefault();
    const content = ["home", "highlights", ...(this.defaultSport ? [this.defaultSport] : [])];
    this.router.navigate(["/app/main", { outlets: { navigation: ["sports"], content } }]);
  }

  getNavIcon(name: string): string {
    const icons: { [key: string]: string } = {
      Casino: "apps",
      "Live Casino": "style",
      Home: "sports_soccer",
      "In-Play": "stadium",
      "Horse Racing": "sports_horse_racing",
      Horse: "sports_horse_racing",
      Greyhound: "pets",
      Virtuals: "sports_esports",
      Sports: "sports_soccer",
      Soccer: "sports_soccer",
      Cricket: "sports_cricket",
      Tennis: "sports_tennis",
      "My Markets": "star",
    };
    return icons[name] || "lens";
  }
}
